import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return " top-border";
},"3":function(container,depth0,helpers,partials,data) {
    return " ";
},"5":function(container,depth0,helpers,partials,data) {
    return "bottom-50";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"commitment-module-class\">\r\n    <div class=\"commitment-to-you\">\r\n      <img src=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"img") || (depth0 != null ? lookupProperty(depth0,"img") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"img","hash":{},"data":data,"loc":{"start":{"line":5,"column":16},"end":{"line":5,"column":23}}}) : helper)))
    + "\" class=\"screenshotImg\" alt=\"\">\r\n      <h2 class=\"heading\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"heading") || (depth0 != null ? lookupProperty(depth0,"heading") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"heading","hash":{},"data":data,"loc":{"start":{"line":6,"column":26},"end":{"line":6,"column":37}}}) : helper)))
    + "</h2>\r\n    </div>\r\n    <div class=\"commitment-sub-text row\">\r\n      <p class=\"sub-text column\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"subText") || (depth0 != null ? lookupProperty(depth0,"subText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"subText","hash":{},"data":data,"loc":{"start":{"line":9,"column":33},"end":{"line":9,"column":44}}}) : helper)))
    + "</p>\r\n    </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"hasContactUs")),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":4},"end":{"line":15,"column":11}}})) != null ? stack1 : "")
    + "  </div>\r\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div>\r\n      <p class=\"contact-link commitment-sub-text\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"contactUsLink") || (depth0 != null ? lookupProperty(depth0,"contactUsLink") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"contactUsLink","hash":{},"data":data,"loc":{"start":{"line":13,"column":50},"end":{"line":13,"column":69}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n    </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"topBorder")),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":12},"end":{"line":1,"column":60}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"hasContactUs")),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(5, data, 0),"data":data,"loc":{"start":{"line":1,"column":61},"end":{"line":1,"column":119}}})) != null ? stack1 : "")
    + "\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"commitmentModuleData") : depth0),{"name":"with","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":17,"column":11}}})) != null ? stack1 : "")
    + "</div>";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.accessible-banking.modules/commitment-module",
  "version": "1.1.5",
  "id": "commitmentModuleId",
  "containerID": "accessibleBankingCommitmentModule",
  "moduleName": "accessible-banking-commitment-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "commitment-module",
  "data": {
    "init": "CommitmentModuleJS",
    "options": {}
  },
  "moduleParams": [{
    "name": "hasContactUs",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "This parameter lets us use the Contact Us link for the Accessible-Banking Homepage only"
  }, {
    "name": "topBorder",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "Allows for the top gray border to show"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.8",
    "@sparta.global.utilities/sparta-style-utility": "^1.0.0"
  },
  "stores": []
};

/**
 * @class CommitmentModuleJS
 * @extends {Module}
 */
class CommitmentModuleJS extends Module {
  /**
   * Creates an instance of commitmentModuleJS
   * @param {Object} options - options
   * @param {Object} context context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * Initializes the module
   * @returns {void}
   */
  init() {}
}
registerModuleClass({
  moduleClass: CommitmentModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { CommitmentModuleJS as default, moduleConfig };
